import { useEffect, useState } from 'react';

import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

import { FileFragment } from '@school_ify/schoolify-repository/src/shared/types';

import Card from 'components/Card/Card';
import FileUploader from 'clean/components/common/FileUploader/FileUploader';

function AssignmentSubmissionDetails(props: {
  model?: {
    assignment_id: any;
    is_submited: boolean;
    completed_at: string;
    files: FileFragment[];
    user_id: any;
    text: string;
    id: null;
    content?: string;
  };
}) {
  const { t } = useTranslation();
  const [files, setFiles] = useState([]);

  useEffect(() => {
    if (props.model.files) {
      setFiles(
        props.model.files.map(file => {
          const dummyFile = new File([''], file.file_name);
          Object.defineProperty(dummyFile, 'id', {
            value: file.id,
            writable: false,
          });
          return dummyFile;
        })
      );
    }
  }, [props.model]);

  if (!props.model) {
    return <></>;
  }
  return (
    <Card>
      <Card.Body>
        <div className="flex gap-1 mb-1 text">
          <span className="text-bold">Submited at:</span>
          {DateTime.fromISO(props.model.completed_at).toFormat('DD HH:mm')}
        </div>
        <div className="flex flex-col mb-1">
          <label htmlFor="content">{t('study:Assignment_submission')}</label>
          <FileUploader readOnly={true} files={files} />
        </div>
        <div className="flex flex-col mb-1">
          <label>{t('grades:Content')}</label>
          <div
            className="ql-editor p-0"
            style={{ padding: 0 }}
            dangerouslySetInnerHTML={{
              __html: props.model.text,
            }}
          />
        </div>
      </Card.Body>
    </Card>
  );
}

export default AssignmentSubmissionDetails;
